export const onClientEntry = () => {
  require("gsap")
  require("scrollmagic")
  require("pixi.js")
}
